import React, { useEffect } from "react";
import {Form, Formik, useFormikContext} from "formik";
import { DefaultButton, Spinner, Stack} from "@fluentui/react";

import useAxios from "axios-hooks";
import { NavigationalButtons } from "./CreateAudioWizard";
import DropDown from "../../../../Forms/DropDown";
import TextField from "../../../../Forms/TextField";
import UploadButton from "../../../../Forms/UploadButton";

const ClosedCaptionStep = ({ nextOnClick, prevOnClick, audioId, audio}) => {

    const [{ data: captions, loading: loadingCaptions }] = useAxios(
        {
          url:`/resources/audio/${audioId}/closed-captions`, method: "get"
        }
    );
  const [{ data: instructors, loading: loadingInstructors }, getAuthors] = useAxios({ url: `resources/audio/authors`, method: "get",});
  const [{ loading, data, error }, postForm] = useAxios(
      {
          url: `/resources/audio/${audioId}/closed-captions`,
          method: "post",
      },
      { manual: true }
  );

  const [{ data: languages, loading: loadingLanguages}] = useAxios(
    {
      url:`/resources/audio/languages`, method: "get"
    });

  if (loadingCaptions || loadingLanguages || loadingInstructors || !audio) {
      return (
          <Spinner className="absolute-center" label="Retrieving Captions..." />
      );
  }

  return (
      <Formik
          initialValues={{closedCaptions: captions}}
          onSubmit={async (values) => {
              try {
                  await postForm({ data:values });
              } catch (e) {
                  throw e;
              }

              nextOnClick();
          }}
      >
    <Form>
          <ClosedCaptionsForm languages={languages} audio={audio} instructors={instructors} loading={loading} prevOnClick={prevOnClick}></ClosedCaptionsForm>
    </Form>
      </Formik>
  );
};


const ClosedCaptionsForm = ({languages, audio, loading, prevOnClick, instructors}) => {

  const languageOptions = languages ? languages.map(language => ({ key: language.languageId.toString(), text: language.name })) : [];
  const filteredInstructors = (audio && audio.audioInstructors && instructors) ?
      instructors.filter(x => audio.audioInstructors.find(y => y.authorId === x.authorId)) : [];

  const [{ data }, uploadCC] = useAxios(
    { url: `resources/audio/upload-closed-caption`, method: "post", headers: { 'content-type': 'multipart/form-data' }},
    { manual: true },
  );

  const { setFieldValue, getFieldProps } = useFormikContext();

  const captionChanged = async (e, i, audioLength) => {
    if (e.target.value) {
        const closedCaptions = getFieldProps("closedCaptions").value;
        const data = new FormData();
        data.append('CaptionFile', e.target.files[0]);
        data.append('AudioId', audio.audioId);
        data.append('Slug', audio.slug);
        data.append('AudioLength', audioLength);
        data.append('LanguageId', closedCaptions[i].languageId);
        data.append('AuthorSlug', getSelectedAuthorName());

        uploadCC({ data })
        .then( (res) => {
          updateAudioCaptionData(`captionUrl${audioLength}Min`, res.data, i);
        })
    }
  }
  const getSelectedAuthorName = () => {
    var selectedAuthorId = getFieldProps("selectedAuthorId").value;
    var selectedAuthor = audio.audioInstructors.find(x => x.authorId === selectedAuthorId);
    return selectedAuthor.firstName + selectedAuthor.lastName
  }

  const updateAudioCaptionData = (k, v, i) => {
    setFieldValue(`closedCaptions[${i}][${k}]`, v);
  }

  const syncAudioInstructors = () => {
    var audioInstructors = audio.audioInstructors;
    var audioInstructorsTmp = getFieldProps("audioInstructorsTmp").value;
 
    //remove deleted instructors
    var filteredInstructors = audioInstructors.filter(x => audioInstructorsTmp.findIndex(y => y.authorId === x.authorId) != -1);

    //add inserted instructors
    var newInstructors = audioInstructorsTmp.filter(x => audioInstructors.findIndex(y => y.authorId === x.authorId) == -1);
    filteredInstructors.push(...newInstructors);

    setFieldValue("audioInstructors", filteredInstructors);
  }

  useEffect(() => {
      if (instructors) {
          const audioInstructors = audio.audioInstructors;
          const filteredInstructors = instructors.filter(x => audioInstructors.findIndex(y => y.authorId === x.authorId) != -1);
          setFieldValue("audioInstructorsTmp", filteredInstructors);
      }
  },[instructors])

  useEffect(() => {
      if (getFieldProps("audioInstructorsTmp").value) {
          syncAudioInstructors();
      }
  }, [getFieldProps("audioInstructorsTmp").value])

  return (
    <Stack
      tokens={{ childrenGap: 20 }}
      styles={{
        root: {
          width: 600,
          paddingTop: 20,
        },
      }}
    >
    {getFieldProps("audioInstructorsTmp")?.value?.length > 0 && 
    <>
      <DropDown 
            label="Choose Meditation Instructor"
            placeholder="Select an instructor"
            options={filteredInstructors && filteredInstructors.map((x,i) => ({key: x.authorId, text: x.name}))}
            name="selectedAuthorId"
            onChange={(e, v) => {
                setFieldValue("selectedAuthorId", v.key);
            }}
            required
      />
    {!isNaN(getFieldProps("selectedAuthorId").value) &&
    <>
      <hr/>
      {getFieldProps("closedCaptions").value.map((x,i) => {
        if (x.authorId != getFieldProps("selectedAuthorId").value) {
          return (<></>);
        }

        return (
        <>
            <DefaultButton 
               styles={{
                root: {
                  backgroundColor: '#d9534f',
                  color: '#fff',
                },
                rootHovered: {
                  backgroundColor: '#ea645f',
                  color: '#fff',
                }        
              }}
              onClick={() => {
                  var closedCaptions = getFieldProps("closedCaptions").value;
                  closedCaptions.splice(i,1);
                  setFieldValue("closedCaptions", closedCaptions);
              }} 
            >
                Remove
            </DefaultButton>
            <DropDown
                key={`languageId${i}`}
                label="CC"
                name={`closedCaptions[${i}].languageId`}
                options={languageOptions}
                required
            />

            <TextField
                key={`captionUrl5Min${i}`}
                label="5 Min CC File Url"
                name={`closedCaptions[${i}].captionUrl5Min`}
                className="mt-0"
                placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                onChange= {(e) => {
                  updateAudioCaptionData("captionUrl5Min", e.target.value, i);
                }}
            />
            <UploadButton 
                key={`5mincaption${i}`}
                name={`5mincaption${i}`} 
                accept=".vtt" 
                label="Upload 5 Min Closed Caption File (.vtt)"
                onChange={async (e) => {captionChanged(e, i, 5)}} 
            />
            <TextField
                key={`captionUrl10Min${i}`}
                label="10 Min CC File Url"
                name={`closedCaptions[${i}].captionUrl10Min`}
                className="mt-0"
                placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                onChange= {(e) => {
                  updateAudioCaptionData("captionUrl10Min", e.target.value, i)
                }}
            />
            <UploadButton 
                key={`10mincaption${i}`}
                name={`10mincaption${i}`}
                accept=".vtt" 
                label="Upload 10 Min Closed Caption File (.vtt)"
                onChange={async (e) => captionChanged(e, i, 10)} 
            />
            <TextField
                key={`captionUrl20Min${i}`}
                label="20 Min CC File Url"
                name={`closedCaptions[${i}].captionUrl20Min`}
                className="mt-0"
                placeholder="If entering manually, enter URL with 'https://cdn.igrad.com/'/' domain" 
                onChange= {(e) => {
                  updateAudioCaptionData("captionUrl20Min", e.target.value, i)
                }}
            />
            <UploadButton 
                key={`20mincaption${i}`}
                name={`20mincaption${i}`} 
                accept=".vtt" 
                label="Upload 20 Min Closed Caption File (.vtt)"
                onChange={async (e) => captionChanged(e, i, 20)} 
            />
            <hr />
        </>
      )})    
      }
    </>
    }
      <DefaultButton onClick={() => {
          var closedCaptions = getFieldProps("closedCaptions").value;
          closedCaptions.push({});
          setFieldValue("closedCaptions", closedCaptions);
          const i = closedCaptions.length - 1;
          setFieldValue(`closedCaptions[${i}].authorId`, getFieldProps("selectedAuthorId").value);
          setFieldValue(`closedCaptions[${i}].languageId`, null);
          setFieldValue(`closedCaptions[${i}].captionUrl5Min`, null);
          setFieldValue(`closedCaptions[${i}].captionUrl10Min`, null);
          setFieldValue(`closedCaptions[${i}].captionUrl20Min`, null);
      }} >
        Add Closed Caption
      </DefaultButton>
    </>
  }

  <NavigationalButtons
        onNextProps={{ type: "submit", text: "Save and Continue" }}
        loading={loading}
        onPrevHandler={prevOnClick}
    />
  </Stack>
  )
}



export default ClosedCaptionStep;
